import React from 'react';

import formatter from '../../../utils/formatters';
import helpers from '../../../utils/helpers';

const activeColumn = (cell) => {
    if (cell) {
        return <i style={{marginLeft:10}} className="material-icons shell-green-text">
            check_circle
        </i>
    } else {
        return <i style={{marginLeft:10}} className="material-icons shell-light-grey-text">
            check_circle_outline
        </i>
    }
};

const booleanColumn = (cell) => {
    return cell ? "Si" : "No"
};

const cuitFormatter = (cell) => {
    return formatter.cuit(cell);
};

const tripType = (cell) => {
    return cell === 'FE' ? 'Fame & Ethanol' : 'Cargas Generales';
};

const groupColumn = (cell) => {
    let groups = helpers.groupsTranslated();
    return groups[cell] ? groups[cell] : cell;
};

const avatarColumn = (cell) => {
    if(!cell || cell === '') return '';
    return <img src={cell} className={'circle grid-img'} alt={"Usuario"} />;
};

const adminColumns = {

    users: [
        {
            dataField: 'is_active',
            text: '',
            boolean: true,
            formatter: activeColumn,
            headerStyle: () => {
                return { width: '60px'};
            },
            style: {width: '60px'}
        },
        {
            dataField: 'profile_image',
            text: '',
            formatter: avatarColumn,
            headerStyle: () => {
                return { width: '50px'};
            },
            style: {width: '50px'}
        },
        {
            dataField: 'first_name',
            text: 'Nombre',
            headerStyle: () => {
                return { width: '120px'};
            },
            style: {width: '120px'}
        },
        {
            dataField: 'last_name',
            text: 'Apellido',
            headerStyle: () => {
                return { width: '120px'};
            },
            style: {width: '120px'}
        },
        {
            dataField: 'email',
            text: 'Correo Electrónico',
            headerStyle: () => {
                return { width: '240px'};
            },
            style: {width: '240px'}
        },
        {
            dataField: 'groups[0].name',
            text: 'Rol',
            formatter: groupColumn,
            headerStyle: () => {
                return { width: '120px'};
            },
            style: {width: '120px'}
        },
        {
            dataField: 'provider.business_name',
            text: 'Proveedor',
            headerStyle: () => {
                return { width: '240px'};
            },
            style: {width: '240px'}
        },
        {
            dataField: 'terminal.name',
            text: 'Terminal',
            headerStyle: () => {
                return { width: '130px'};
            },
            style: {width: '130px'}
        },
    ],

    providers: [
        {
            dataField: 'active',
            text: 'Activo',
            boolean: true,
            formatter: activeColumn
        },
        {
            dataField: 'business_name',
            text: 'Razón Social',
        },
        {
            dataField: 'cuit',
            text: 'CUIT',
            formatter: cuitFormatter
        },
        {
            dataField: 'email',
            text: 'Correo electrónico',
        },
        {
            dataField: 'can_create_cif_trips',
            text: '¿Crea viajes?',
            boolean: true,
            formatter: booleanColumn
        }
    ],

    products: [
        {
            dataField: 'active',
            text: 'Activo',
            formatter: activeColumn
        },
        {
            dataField: 'name',
            text: 'Nombre',
        },
        {
            dataField: 'trip_type',
            text: 'Tipo de Viaje',
            formatter: tripType
        }
    ],

    terminals: [
        {
            dataField: 'active',
            text: 'Activo',
            formatter: activeColumn
        },
        {
            dataField: 'code',
            text: 'Código',
        },
        {
            dataField: 'name',
            text: 'Nombre',
        }
    ],

    areas: [
        {
            dataField: 'active',
            text: 'Activo',
            formatter: activeColumn
        },
        {
            dataField: 'code',
            text: 'Código',
        },
        {
            dataField: 'name',
            text: 'Nombre',
        }
    ],

    scales: [
        {
            dataField: 'code',
            text: 'Código',
        },
        {
            dataField: 'terminal.name',
            text: 'Terminal',
        }
    ],

    islands: [
        {
            dataField: 'active',
            text: 'Activo',
            formatter: activeColumn
        },
        {
            dataField: 'code',
            text: 'Código',
        },
        {
            dataField: 'name',
            text: 'Nombre',
        },
        {
            dataField: 'terminal.name',
            text: 'Terminal',
        }
    ],

    meters: [
        {
            dataField: 'active',
            text: 'Activo',
            formatter: activeColumn
        },
        {
            dataField: 'code',
            text: 'Código',
        },
        {
            dataField: 'product.name',
            text: 'Producto',
        },
        {
            dataField: 'loading_island.terminal.name',
            text: 'Terminal',
        },
        {
            dataField: 'loading_island.name',
            text: 'Isla de Descarga',
        },
    ],

    reasons: [
        {
            dataField: 'code',
            text: 'Código',
        },
        {
            dataField: 'text',
            text: 'Texto',
        },
        {
            dataField: 'trip_type',
            text: 'Tipo de Viaje',
            formatter: tripType
        }
    ],

    audits: [
        {
            dataField: 'active',
            text: 'Activo',
            formatter: activeColumn
        },
        {
            dataField: 'description',
            text: 'Descripción',
        }
    ]
};

export default adminColumns;



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Admin/columns.js